<template>
    <div class="container" :style="{'min-height': height+'px'}">
        <div class="tle">
            <router-link to="/invoiceList"><span><i class="iconfont">&#xe703;</i>申请发票</span></router-link>
        </div>
        <div class="content">
            <div class="tips">
                <p>1.当前发票默认开具普通电子发票（具有同等法律效力，可支持报销入账），如需其它发票请填写备注。</p>
                <p>2.请务必确保填写准确真实的信息。</p>
                <p>3.带*的为必填项。</p>
            </div>
            <Form ref="form_params" :model="form_params" :rules="ruleValidate">
                <div class="form-div">
                    <FormItem prop="total">
                        <p class="tletle"><span class="red">*</span>申请金额</p>
                        <Input v-model="form_params.total" placeholder="请输入申请金额"></Input>
                    </FormItem>
                    <FormItem prop="title">
                        <p class="tletle"><span class="red">*</span>发票抬头</p>
                        <Input v-model="form_params.title" placeholder="请输入发票抬头"></Input>
                    </FormItem>
                    <FormItem prop="nsr_code">
                        <p class="tletle"><span class="red">*</span>纳税人识别号</p>
                        <Input v-model="form_params.nsr_code" placeholder="请输入纳税人识别号"></Input>
                    </FormItem>
                    <FormItem prop="contact_name">
                        <p class="tletle"><span class="red">*</span>联系人</p>
                        <Input v-model="form_params.contact_name" placeholder="请输入发票收件人姓名"></Input>
                    </FormItem>
                    <FormItem prop="contact_tel">
                        <p class="tletle"><span class="red">*</span>联系电话</p>
                        <Input v-model="form_params.contact_tel" placeholder="请输入收件人联系方式"></Input>
                    </FormItem>
                    <FormItem prop="contact_email">
                        <p class="tletle"><span class="red">*</span>联系邮箱</p>
                        <Input v-model="form_params.contact_email" placeholder="请输入收件人邮箱"></Input>
                    </FormItem>
                    <FormItem prop="addres">
                        <p class="tletle"><span class="red">*</span>寄送地址</p>
                        <Input v-model="form_params.addres" placeholder="请输入电子发票寄送地址"></Input>
                    </FormItem>
                    <FormItem prop="remark">
                        <p class="tletle">备注</p>
                        <Input v-model="form_params.remark" placeholder="如需其它发票请填写备注"></Input>
                    </FormItem>
                    <FormItem prop="img_path">
                        <p class="tletle"><span class="red">*</span>上传凭证</p>
                            <div class="upload-list" v-if="img_path">
                                <img :src="img_path" />
                                <!-- <div class="upload-list-cover">
                                    <Icon type="ios-trash-outline" @click="handleRemove()"></Icon>
                                </div> -->
                            </div>
                            <Upload
                                class="upload-img"
                                ref="upload_img"
                                :data="form_params"
                                :action="upload_action"

                                :on-success="uploadSuccess"
                                :max-size="2048"
                                :on-exceeded-size="uploadExceeded"
                                :format="['jpg','jpeg','png']"
                                :on-format-error="uploadError"
                                :before-upload="handleBeforeUpload"
                                :show-upload-list="false"
                            >
                                <div class="icon-div">
                                    <i class="iconfont">&#xe665;</i>
                                </div>
                            </Upload>
                            <div class="msg">
                                <p>1.请提供完整清晰的凭证</p>
                                <p>2.建议大小2M以下</p>
                                <p>3.支持的图片格式PNG/JPG/JPEG</p>
                            </div>
                        </FormItem>
                </div>

                <div class="option-div">
                    <div class="btn" v-if="!invoiceData.id" @click="submit('form_params')">申请发票</div>
                    <div class="btn" v-if="invoiceData.id && invoiceData.status == '0'" @click="upload('form_params')">修改信息</div>
                    <div class="btn" v-if="invoiceData.status == '1'">审核通过</div>
                </div>
            </Form>

        </div>
    </div>
</template>

<script>
import 'mstyles/style.styl'
import { _applyInvoice,_updateInvoice,updateInvoice } from '../../../service'

export default {
    props:{
        invoiceData:{
            tyoe:Object,
            default: function () {
                return {}
            }
        }
    },
    data(){
        //自定义手机号
        const validatePhone = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('手机号不能为空'));
            } else if (!/^1[34578]\d{9}$/.test(value)) {
                callback('手机号格式不正确');
            } else {
                callback();
            }
        }
        return {
            height:0,
            upload_action: _applyInvoice,
            file: '',
            img_path:'',
            form_params:{
                total:'',
                title:'',
                nsr_code:'',
                contact_name:'',
                contact_tel:'',
                contact_email:'',
                addres:'',
                remark:'',
                img_path:''
            },
            ruleValidate: {
                total: [
                    { required: true, message: '请输入申请金额', trigger: 'blur' },
                    { type: "number", transform(value) { return Number(value) }, trigger: 'blur', message: '请输入数字' }
                ],
                title: [
                    { required: true, message: '请输入发票抬头', trigger: 'blur' }
                ],
                nsr_code: [
                    { required: true, message: '请输入纳税人识别号', trigger: 'blur' }
                ],
                contact_name: [
                    { required: true, message: '请输入发票收件人姓名', trigger: 'blur' }
                ],
                contact_tel: [
                    { required: true,validator:validatePhone,trigger:'blur'}
                ],
                contact_email: [
                    { required: true, message: '请输入收件人邮箱', trigger: 'blur' },
                    { type: 'email', message: '请输入正确的收件人邮箱', trigger: 'blur' }
                ],
                addres: [
                    { required: true, message: '请输入电子发票寄送地址', trigger: 'blur' }
                ],
                img_path: [
                    { required: true, message: '请上传凭证', trigger: 'change' }
                ]
            }
        }
    },
    computed: {
        user_key() {
            return this.$store.state.user_key
        },
        img_req_url() {
            return this.$store.state.img_req_url
        }
    },
    methods:{
        handleBeforeUpload(file) {
            this.file = file //需要传给后台的file文件
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = () => {
                const _base64 = reader.result
                this.img_path = _base64 //将_base64赋值给图片的src，实现图片预览
            }
            return false //阻止图片继续上传，使得form表单提交时统一上传
        },

        uploadSuccess (res) {
          this.$Message.success("上传成功!")
          this.$router.push({name: 'InvoiceList'})
        },

        uploadError(res) {
          this.$Message.error("请上传正确的图片格式");
        },
        uploadExceeded() {
          this.$Message.error('上传的图片大小请限制2MB以内')
        },

        submit (name) {
            if(this.file){
                this.form_params.img_path = '-1'
            }
            this.$refs[name].validate((valid) => {
                if (valid) {
                    this.form_params.user_key = this.user_key
                    this.$refs['upload_img'].post(this.file)
                }
            })
        },

        async upload (name) {
            this.form_params.user_key = this.user_key
            this.form_params.invoice_id = this.form_params.id
            if(this.file){
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        this.$refs['upload_img'].post(this.file)
                    }
                })
            }else{
                let res = await updateInvoice(this.form_params, (error) => {this.$Message.error('请求错误!')})
            }

        },

        handleRemove(){
            this.img_path = ''
        }
    },
    mounted(){
        this.height = document.documentElement.clientHeight + ''
        if(this.invoiceData.id){
            this.form_params = this.invoiceData
            this.img_path = this.img_req_url + this.form_params.img_path
            this.upload_action = _updateInvoice
        }
    }
}
</script>

<style lang="stylus" scoped>
@import '../styles/common.styl'

.content
    padding-bottom: 2.05rem
    .tips
        padding: .31rem 0
        font-size: .24rem
        color: #666666
        line-height: .36rem
    .form-div
        background: #FFFFFF
        padding: .22rem .32rem .1rem .32rem
        border-radius: .1rem
        color: #999999
        .tletle
            font-size: .28rem
            line-height: .42rem
        .red
            color: #F3494B
.msg
  line-height: 1.5
</style>
